export default {"src":"https://gh-fe.gsxcdn.com/gtbg-fe/book-content/_next/static/media/back.42d50bdc.svg","height":32,"width":32};